export default __webpack_public_path__ + "static/media/card2400.ffd665a7.jpg";